// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Counterparty } from './counterparty';
import { CounterpartyType } from './counterparty-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CounterpartyCounterpartyType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyId!: number;
  counterpartyTypeId!: number;
  ts!: string;
  counterparty!: Counterparty;
  counterpartyType!: CounterpartyType;
}

